import { render, staticRenderFns } from "./TestLead.vue?vue&type=template&id=40497972"
import script from "./TestLead.vue?vue&type=script&lang=js"
export * from "./TestLead.vue?vue&type=script&lang=js"
import style0 from "./TestLead.vue?vue&type=style&index=0&id=40497972&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports